// extracted by mini-css-extract-plugin
module.exports = {"rateCardTableItemList":"RateCardTableItemList_rateCardTableItemList__1_PJg","rateCardTableItem":"RateCardTableItemList_rateCardTableItem__2t9d4"};